import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCheckbox,{attrs:{"label":_vm.labelComposed,"indeterminate":_vm.indeterminate,"hide-details":""},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})}
var staticRenderFns = []

export { render, staticRenderFns }